import { useState } from 'react';

import Home from '@/assets/home.svg?react';
import { useStepper } from '@/features/v2/lib/stepper';
import InputAddress from '@/features/v2/summaryForms/components/InputAdress';
import InputBuildingNumber from '@/features/v2/summaryForms/components/InputBuildingNumber';
import InputCity from '@/features/v2/summaryForms/components/InputCity';
import InputFlatNumber from '@/features/v2/summaryForms/components/InputFlatNumber';
import InputPostalCode from '@/features/v2/summaryForms/components/InputPostalCode';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

const PREFIX = 'damage_location';

export const DAMAGE_LOCATION_ADDRESS = 'damage_location.address';
export const DAMAGE_LOCATION_ZIP_CODE = 'damage_location.zip_code';
export const DAMAGE_LOCATION_CITY = 'damage_location.city';
export const DAMAGE_LOCATION_BUILDING_NUMBER =
  'damage_location.building_number';
export const DAMAGE_LOCATION_FLAT_NUMBER = 'damage_location.flat_number';

const SurveyTwo = () => {
  const { step } = useStepper();
  const { i18n } = useLingui();
  const [focused, setFocused] = useState('');

  const { watch } = useFormContext();

  const postalCode = watch(DAMAGE_LOCATION_ZIP_CODE);
  const city = watch(DAMAGE_LOCATION_CITY);
  const address = watch(DAMAGE_LOCATION_ADDRESS);

  return (
    <>
      {step >= 1 && (
        <div
          className={cn(
            'w-full max-w-full rounded-[10px] border-t-[6px] border-blue-600 bg-gray-100 px-3.5 py-4 md:rounded-lg md:p-6'
          )}
        >
          <h4>{i18n.t('Gdzie wydarzyła się szkoda?')}</h4>
          <div className="mt-3 grid grid-cols-4 flex-col gap-3 rounded-md bg-gray-200 p-3.5 md:p-6">
            <p className="h5 col-span-4 flex items-center gap-2">
              <Home className="size-4 shrink-0 text-blue-600" />
              {i18n.t('Adres szkody')}
            </p>
            <InputPostalCode
              name={DAMAGE_LOCATION_ZIP_CODE}
              focused={focused}
              setFocused={setFocused}
              prefix={PREFIX}
              controlled
            />
            <InputCity
              name={DAMAGE_LOCATION_CITY}
              focused={focused}
              setFocused={setFocused}
              disabled={!postalCode || (postalCode && postalCode?.length < 6)}
              prefix={PREFIX}
              controlled
            />
            <InputAddress
              name={DAMAGE_LOCATION_ADDRESS}
              focused={focused}
              setFocused={setFocused}
              disabled={!city}
              prefix={PREFIX}
              controlled
              creatable
            />
            <div className="col-span-4 grid grid-cols-4 gap-3">
              <InputBuildingNumber
                name={DAMAGE_LOCATION_BUILDING_NUMBER}
                focused={focused}
                setFocused={setFocused}
                disabled={!address}
              />
              <InputFlatNumber
                name={DAMAGE_LOCATION_FLAT_NUMBER}
                focused={focused}
                setFocused={setFocused}
                disabled={!address}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SurveyTwo;
